"use client";

import { Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useI18n } from "@/locales/client";

interface ThankYouStepProps {
  firstName: string;
  onStay: () => void;
  onContinueCanceling: () => void;
  isCanceling: boolean;
}

export const ThankYouStep = ({
  firstName,
  onStay,
  onContinueCanceling,
  isCanceling,
}: ThankYouStepProps) => {
  const t = useI18n();

  return (
    <div className="flex flex-col items-center gap-6 text-center">
      <div className="text-5xl">🙏</div>

      <div className="space-y-2">
        <h3 className="text-xl font-semibold text-foreground">
          {/* @ts-expect-error */}
          {t("cancellation.thankYou.heading", { name: firstName })}
        </h3>
        <p className="text-sm text-muted-foreground">
          {t("cancellation.thankYou.description")}
        </p>
      </div>

      <div className="rounded-xl bg-muted/50 px-6 py-4 w-full">
        <p className="text-sm text-muted-foreground">
          💡 {t("cancellation.thankYou.note")}
        </p>
      </div>

      <div className="flex flex-col gap-2 w-full">
        <Button onClick={onStay} className="w-full">
          {t("cancellation.thankYou.stay")}
        </Button>
        <Button
          variant="dangerOutline"
          onClick={onContinueCanceling}
          disabled={isCanceling}
          className="w-full"
        >
          {isCanceling && <Loader2 className="mr-2 size-4 animate-spin" />}
          {t("cancellation.thankYou.stillCancel")}
        </Button>
      </div>
    </div>
  );
};
